module.exports = __webpack_public_path__ + "media/images/rank/check-gold-b3c00213a18d0b704e7b4e00002a7918.png";